import { render, staticRenderFns } from "./activityAddTest.vue?vue&type=template&id=dda653d4&scoped=true"
import script from "./activityAddTest.vue?vue&type=script&lang=js"
export * from "./activityAddTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda653d4",
  null
  
)

export default component.exports